(function($, undefined) {
	
	'use strict';
	const FIRST_SAVE_TIMEOUT = 5000; // 5 seconds into the page
	const SAVE_INTERVAL = 60 * 5000; // every 5 minutes
	const MIN_TEXT_LENGTH = 30;
	var audioRecorder;
	var intervalId;
	var isGenDataSaveComplete = false;
	var gendataSaveInfo;
	var currentHref;
	var baseAllSavesJson = { "allSaves": []};
	var baseSavesJson = {"timeSpent": "00:00", "saves": []};
	var startTime;
	
	var needLeavingConfirmation;
	
	var init = function () {
		startTime = getCurrentTime();
		
		audioRecorder = Fw.component.models().AudioRecorder;
		gendataSaveInfo = $('.gendata-save-info');
		isGenDataSaveComplete = gendataSaveInfo.attr('data-is-complete') == 'true' ? true : false;
		currentHref = window.location.href;
		
		setCurrentSaveIndex();
		
		$('.exercise-detail-ctn .save-exercise-btn').on('click', function() {
			needLeavingConfirmation = false;
			saveCurrentExercise(true, function() {
				window.location.href = currentHref.substr(0, currentHref.lastIndexOf('/'));
			});
		});
		
		$('.exercise-detail-ctn').on('exercise-state-change', onExerciseChange);
		$('.exercise-detail-ctn').on('exercise-completion-change', detectExerciseCompleted);
		
		if ($('.exercise-detail-ctn').length > 0 && $('body').hasClass('is-student-logged')) {
			needLeavingConfirmation = true;
			/*setTimeout(function() {
				saveCurrentExercise(isGenDataSaveComplete);
				startSaveInterval();
			}, FIRST_SAVE_TIMEOUT);*/
		}
	};
	
	var setCurrentSaveIndex = function() {
		var currentSavesJson = gendataSaveInfo.attr('data-current-saves');
		var currentSavesObj = currentSavesJson ? JSON.parse(currentSavesJson) : baseAllSavesJson;
		var lastIndex = currentSavesObj.allSaves.length > 0 ? currentSavesObj.allSaves.length : 0;
		
		gendataSaveInfo.attr('data-current-index', lastIndex);
	};
	
	var onExerciseChange = function() {
		$('.exercise-detail-ctn').addClass('processing');
		saveCurrentExercise(false, function() {
			$('.exercise-detail-ctn').removeClass('processing');
			detectExerciseCompleted();
			detectExercisePartsSuccess();
		});	
	};
	
	/*var startSaveInterval = function() {
		intervalId = setInterval(function() {
			saveCurrentExercise(isGenDataSaveComplete);	
		}, SAVE_INTERVAL);
	};*/
	
	
	var saveCurrentExercise = function(isComplete, callback = () => {}) {
		if (isComplete) {
			audioRecorder.saveRecording(function(exception) { // saves recording if needed, otherwise goes on directly to the callback
				if (!exception) {
					saveDataInAttribute();
					setTimeSpent();
					saveGenData(isComplete, callback);
				}
			});
		}
		else {
			saveDataInAttribute(callback);
		}
	};
	
	var updateMeliMeloExerciseData = function(data) {
		data.images = getImagesPathList($('.image-sorter-list-item .image'));
		data.triesLeft = getTriesLeft();
		data.hasSuccess = exerciseHasSuccess();
		data.text = getFreeText();
		data.audio = getFreeAudio();
	};
	
	var updateRaconteMoiExerciseData = function(data) {
		data.text = getFreeText();
		data.audio = getFreeAudio();
	};
	
	var updateOuvreLesYeuxExerciseData = function(data) {
		data.images = getImageSelectorData($('.exercise-item-selector'));
		data.triesLeft = getTriesLeft();
		data.hasSuccess = exerciseHasSuccess();
	};
	
	var updateDevineExerciseData = function(data) {
		data.images = getImageSelectorData($('.exercise-item-selector'));
		data.triesLeft = getTriesLeft();
		data.hasSuccess = exerciseHasSuccess();
	};
	
	var updateLeDetectiveExerciseData = function(data) {
		data.texts = getTextSelectorData($('.text-selector-item-student'));
		data.triesLeft = getTriesLeft();
		data.hasSuccess = exerciseHasSuccess();
	};
	
	var setTimeSpent = function() {
		var timeSpentMilliseconds = getCurrentTime() - startTime;
		var spentMinutes = Math.round(timeSpentMilliseconds / (1000 * 60));
		var spentSeconds = Math.round(timeSpentMilliseconds % 60);		
		spentMinutes = spentMinutes < 10 ? '0' + spentMinutes : spentMinutes;
		spentSeconds = spentSeconds < 10 ? '0' + spentSeconds : spentSeconds;
		var timeSpentString = spentMinutes + ':' + spentSeconds;
		
		var currentIndex = gendataSaveInfo.attr('data-current-index');
		var currentSavesJson = gendataSaveInfo.attr('data-current-saves');
		var currentAllSavesObj = currentSavesJson.length > 0 ? JSON.parse(currentSavesJson) : baseAllSavesJson;
		
		currentAllSavesObj.allSaves[currentIndex].timeSpent = timeSpentString;		
		
		gendataSaveInfo.attr('data-current-saves', JSON.stringify(currentAllSavesObj));	
	};
	
	var saveGenData = function(isComplete, callback = () => {}) {
		var id = gendataSaveInfo.attr('data-save-gendata-id');
		var studentId = gendataSaveInfo.attr('data-student-id');
		var activityId = gendataSaveInfo.attr('data-activity-id');
		var exerciseId = gendataSaveInfo.attr('data-exercise-id');
		var level = gendataSaveInfo.attr('data-level');
		var currentSavesJson = gendataSaveInfo.attr('data-current-saves');
		
		var params = {
			field6: isComplete,
			field7: currentSavesJson,
			ajax: true	
		};
		if (id) { 
			params.id = id; 
		}
		else {
			params.field1 = 'exercise-save';
			params.field2 = studentId;
			params.field3 = activityId;
			params.field4 = exerciseId;
			params.field5 = level;
		}
		
		$.ajax({
			url: "/action/manageGenData",
			method: "post",
			data: params,
			complete: function(response) {
				console.log(response.responseText);
				if (!id) {
					var createdId = response.responseText.replace('success-', '');
					gendataSaveInfo.attr('data-save-gendata-id', createdId);
				}
				gendataSaveInfo.attr('data-is-complete', isComplete);
				isGenDataSaveComplete = isComplete;
				
				callback(response.responseText);
			}
		});
	};
	
	var saveDataInAttribute = function(callback = () => {}) {
		var container = $('.exercise-detail-ctn');
		var newData = {
			"date": getCurrentDate()
		};
		
		if (container.hasClass('meli-melo')) {
			updateMeliMeloExerciseData(newData);
		} else if (container.hasClass('raconte-moi')) {
			updateRaconteMoiExerciseData(newData);
		} else if (container.hasClass('ouvre-les-yeux')) {
			updateOuvreLesYeuxExerciseData(newData);	
		} else if (container.hasClass('devine')) {
			updateDevineExerciseData(newData);
		} else if (container.hasClass('le-detective')) {
			updateLeDetectiveExerciseData(newData);
		} else {
			console.log('unrecognized class: ' + container.attr('class'));
		}
		
		var currentIndex = gendataSaveInfo.attr('data-current-index');
		var currentSavesJson = gendataSaveInfo.attr('data-current-saves');
		var currentAllSavesObj = currentSavesJson.length > 0 ? JSON.parse(currentSavesJson) : baseAllSavesJson;
		var currentObjExists = currentAllSavesObj.allSaves[currentIndex];
		var currentSavesObj = currentObjExists ? currentAllSavesObj.allSaves[currentIndex] : baseSavesJson;
		
		currentSavesObj.saves.push(newData);
		
		
		var allSavesJson = currentAllSavesObj;
		if (currentObjExists) {
			allSavesJson.allSaves[currentIndex] = currentSavesObj;		
		} else {
			allSavesJson.allSaves.push(currentSavesObj);	
		}
		
		gendataSaveInfo.attr('data-current-saves', JSON.stringify(allSavesJson));
		callback();
	};
	
	
	/**
	 * Get current date in ISO format without the 'T', 'Z' and the milliseconds
	 */
	var getCurrentDate = function() {
		return moment().format('YYYY/MM/DD HH:mm:ss');
		/*var date = new Date();
		var isoDate = date.toISOString();
		return isoDate.substr(0, isoDate.indexOf('.')).replace('T', ' ').replace('Z', '');*/
	};
	
	var getCurrentTime = function() {
		var date = new Date();
		return date.getTime();
	};
	
	var getTriesLeft = function() {
		return $('.exercise-tries-left .num').first().text();
	};
	
	var getImagesPathList = function(images) {
		var imagesArray = [];
		images.each(function(i, el) {
			let src = $(el).attr('src');
			imagesArray.push(src.length > 0 ? src : "");
		});
		return imagesArray;
	};
	
	var getImageSelectorData = function(items) {
		var dataArray = [];
		items.each(function(i, el) {
			var item = $(el);
			var isSelected = item.hasClass('success') || item.hasClass('error');
			dataArray.push({
				"image": item.find('img').attr('src'),
				"isSelected" : isSelected,
				"hasSuccess": item.hasClass('success')
			});
		});
		return dataArray;
	};
	
	var getTextSelectorData = function(items) {
		var dataArray = [];
		items.each(function(i, el) {
			var item = $(el);
			var isSelected = item.hasClass('success') || item.hasClass('error');
			dataArray.push({
				"index": item.attr('data-index'),
				"isSelected" : isSelected
			});
		});
		return dataArray;
	};
	
	var getFreeText = function() {
		return $('.tell-story-textarea').val();
	};
	
	var getFreeAudio = function() {
		var mediaId = $('.record-audio-ctn').attr('data-media-id');
		return mediaId ? mediaId : "";
	};
	
	var isExerciseCompleted = function() {
		if ($('.image-selector-ctn').length > 0 && !isImageSelectorSuccess()) {
			return false;
		}
		if ($('.texts-selector-student-ctn').length > 0 && !isTextSelectorSuccess()) {
			return false;
		}
		if ($('.images-sorter-ctn').length > 0 && !isImageSorterSuccess()) {
			return false;
		}
		if ($('.tell-story-textarea').length > 0) {
			if (getFreeText().length === 0 && !audioRecorder.hasRecording()) {
				return false;
			}
		}
		
		return true;
	};
	
	var isImageSelectorSuccess = function() {
		var data = getImageSelectorData($('.image-selector-item'));
		var selectedData = data.filter(function(item) {
			var selectedItem = $('.image-selector-item .image').filter('[src="' + item.image + '"]').closest('.image-selector-item');
			return item.isSelected && selectedItem.hasClass('success');
		});
		return selectedData.length > 0;
	};
	
	var isTextSelectorSuccess = function() {
		var data = getTextSelectorData($('.text-selector-item-student'));
		var selectedData = data.filter(function(item) {
			var selectedItem = $('.text-selector-item-student').filter('[data-index="' + item.index + '"]');
			return item.isSelected && selectedItem.hasClass('success');
		});
		return selectedData.length > 0;
	};
	
	var isImageSorterSuccess = function() {
		return $('.images-sorter-list-ctn').hasClass('success');
	};
	
	
	var detectExerciseCompleted = function() {
		var exerciseCompleted = isExerciseCompleted();
		$('.save-exercise-btn').attr('disabled', !exerciseCompleted);
	};
	
	var detectExercisePartsSuccess = function() {
		if ($('.image-selector-ctn').length > 0 && isImageSelectorSuccess()) {
			$('.image-selector-ctn').addClass('disabled');
		}
		if ($('.texts-selector-student-ctn').length > 0 && isTextSelectorSuccess()) {
			$('.texts-selector-student-ctn').addClass('disabled');
		}
		if ($('.images-sorter-ctn').length > 0 && isImageSorterSuccess()) {
			$('.images-sorter-ctn').addClass('disabled');
		}
	};
	
	var exerciseHasSuccess = function() {
		var hasSuccess = false;
		if ($('.image-selector-ctn').length > 0 && isImageSelectorSuccess()) {
			hasSuccess = true;
		}
		if ($('.texts-selector-student-ctn').length > 0 && isTextSelectorSuccess()) {
			hasSuccess = true;
		}
		if ($('.images-sorter-ctn').length > 0 && isImageSorterSuccess()) {
			hasSuccess = true;
		}
		return hasSuccess;
	};
	
	$(window).ready(function () {
		init();
	});
	
	/**
	 * Demande au user s'il veut vraiment quitter sans enregistrer. Le texte returned n'apparait pas sur tous les navigateurs, c'est normal.
	 */
	window.addEventListener("beforeunload", function(event) {
	    if(needLeavingConfirmation) {
	        event.returnValue = "Si tu quittes la page sans enregistrer ton exercice, ce que tu as fait sera effacé.";
	        return "Si tu quittes la page sans enregistrer ton exercice, ce que tu as fait sera effacé.";
	    }
	});
	
})(jQuery);
